import React from "react";
import HeroCard from "@/components/heroCard";
import { HERO_CONSTANTS } from "./constants";

const Hero = () => {
  return (
    <HeroCard
      backgroundImage="/zadaraMigration/header-zadara-migration.png"
      {...HERO_CONSTANTS}
    />
  );
};

export default Hero;
